import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { I18nextProvider } from 'react-i18next'
import i18n from './i18n'

// Start the mocking conditionally.
if (process.env.NODE_ENV === 'development') {
  const { worker } = require('./__mocks__/browser')
  worker.start()
}
const container = document.getElementById('root')
const root = createRoot(container)
// root.render(<React.StrictMode><App /></React.StrictMode>)
root.render(
  <I18nextProvider i18n={i18n}>
    <App />
  </I18nextProvider>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
